module.exports = "/packs/fv_img-pc-3ebe46d2460b26ee00c66ba441ffb89a.png";